/* src/app/components/lead-details/participant-information/lead-detail-services/lead-detail-services.component.css */
[nz-icon] {
  margin-right: 6px;
  font-size: 1.429rem;
  color: #3c86f5;
  cursor: pointer;
}
/*# sourceMappingURL=lead-detail-services.component-SQXZ6CJF.css.map */
